import { Directive, ElementRef, NgZone, type OnDestroy, type OnInit, output, inject } from '@angular/core';
import { type ResizedEvent } from '../models/resized-event.model';
import { PlatformService } from '../services/platform.service';

@Directive({
    selector: '[bigSharedResized]',
})
export class ResizedDirective implements OnInit, OnDestroy {
    private readonly element = inject(ElementRef);
    private readonly zone = inject(NgZone);
    private readonly platformService = inject(PlatformService);

    public readonly bigSharedResized = output<ResizedEvent>();

    private observer: ResizeObserver | undefined;
    private oldRect?: DOMRectReadOnly;

    public ngOnInit(): void {
        if (this.platformService.isPlatformServer()) {
            return;
        }

        this.observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
            this.zone.run(() => {
                this.observe(entries);
            });
        });

        this.observer.observe(this.element.nativeElement);
    }

    public ngOnDestroy(): void {
        if (this.platformService.isPlatformServer()) {
            return;
        }

        this.observer?.disconnect();
    }

    private observe(entries: ResizeObserverEntry[]): void {
        const domSize: ResizeObserverEntry = entries[0];
        const resizedEvent: ResizedEvent = { newRect: domSize.contentRect, oldRect: this.oldRect };
        this.oldRect = domSize.contentRect;
        this.bigSharedResized.emit(resizedEvent);
    }
}
